import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { Header } from 'semantic-ui-react';
import { UIActions } from '../../constants/actions';

type PageTitleProps = {
  newPageTitle: string;
  newPageSubtitle?: string;
};

const PageTitle = (props: PageTitleProps) => {
  const { newPageTitle, newPageSubtitle } = props;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({
      type: UIActions.SET_PAGE_TITLE,
      payload: newPageTitle,
    });
  }, [dispatch, newPageTitle]);

  return newPageSubtitle ? (
    <SectionDiv>
      <Header.Subheader>{newPageSubtitle}</Header.Subheader>
    </SectionDiv>
  ) : null;
};

export default PageTitle;

export const Container = styled.div`
  padding: 30px;
`;

export const SectionDiv = styled.div`
  padding-bottom: 35px;
`;
